import React from 'react';
import {useNavigate} from 'react-router-dom';
import {Box, Card, CardContent, Container, Typography} from '@mui/material';
import {Business, Event as EventIcon, People, Person} from '@mui/icons-material';
import {useAuth} from '../../context/AuthContext';
import {translateRole} from '../../utils/enumTranslations';
import '../../assets/styles/pages/Dashboard.scss';

const Dashboard = () => {
    const navigate = useNavigate();
    const {user, isAdmin, isSupervisor} = useAuth();

    const quickActions = [
        {
            title: 'Übungsdienste',
            description: 'Verwalten Sie Ihre Übungsdienste',
            icon: <EventIcon sx={{fontSize: 60}}/>,
            path: '/events',
            show: isSupervisor(),
            color: '#1976d2'
        },
        {
            title: 'Mitglieder',
            description: 'Verwalten Sie Ihre Mitglieder',
            icon: <People sx={{fontSize: 60}}/>,
            path: '/members',
            show: isSupervisor(),
            color: '#00796b'
        },
        {
            title: 'Profil',
            description: 'Verwalten Sie Ihr Benutzerprofil',
            icon: <Person sx={{fontSize: 60}}/>,
            path: '/profile',
            show: true,
            color: '#9c27b0'
        },
        {
            title: 'Benutzer verwalten',
            description: 'Verwalten Sie alle Benutzer im System',
            icon: <People sx={{fontSize: 60}}/>,
            path: '/admin/users',
            show: isAdmin(),
            color: '#2e7d32'
        },
        {
            title: 'Einheiten verwalten',
            description: 'Verwalten Sie Feuerwehr-Einheiten',
            icon: <Business sx={{fontSize: 60}}/>,
            path: '/admin/units',
            show: isAdmin(),
            color: '#ed6c02'
        }
    ];

    return (
        <Container maxWidth="lg" className="dashboard-container" sx={{mt: 4, mb: 4}}>
            <Box sx={{mb: 4}}>
                <Typography variant="h4" gutterBottom>
                    Willkommen, {user?.firstName}!
                </Typography>
                <Typography variant="body1" color="textSecondary">
                    Jugendfeuerwehr Management System
                </Typography>
            </Box>

            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: {
                        xs: '1fr',
                        sm: 'repeat(2, 1fr)',
                        md: 'repeat(3, 1fr)'
                    },
                    gap: 3
                }}
            >
                {quickActions.filter(action => action.show).map((action, index) => (
                    <Card
                        key={index}
                        sx={{
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            cursor: 'pointer',
                            transition: 'transform 0.2s, box-shadow 0.2s',
                            '&:hover': {
                                transform: 'translateY(-4px)',
                                boxShadow: 6
                            }
                        }}
                        onClick={() => navigate(action.path)}
                    >
                        <CardContent sx={{textAlign: 'center', flexGrow: 1}}>
                            <Box
                                sx={{
                                    color: action.color,
                                    mb: 2,
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}
                            >
                                {action.icon}
                            </Box>
                            <Typography variant="h6" gutterBottom>
                                {action.title}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                {action.description}
                            </Typography>
                        </CardContent>
                    </Card>
                ))}
            </Box>

            {user && (
                <Box sx={{mt: 4}}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Ihre Informationen
                            </Typography>
                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: {
                                        xs: '1fr',
                                        sm: 'repeat(2, 1fr)'
                                    },
                                    gap: 2
                                }}
                            >
                                <Box>
                                    <Typography variant="body2" color="textSecondary">
                                        Name:
                                    </Typography>
                                    <Typography variant="body1">
                                        {user.firstName} {user.lastName}
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography variant="body2" color="textSecondary">
                                        E-Mail:
                                    </Typography>
                                    <Typography variant="body1">
                                        {user.email}
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography variant="body2" color="textSecondary">
                                        Rolle:
                                    </Typography>
                                    <Typography variant="body1">
                                        {translateRole(user.role)}
                                    </Typography>
                                </Box>
                                {user.unit && (
                                    <Box>
                                        <Typography variant="body2" color="textSecondary">
                                            Einheit:
                                        </Typography>
                                        <Typography variant="body1">
                                            {user.unit.name}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
            )}
        </Container>
    );
};

export default Dashboard;

